// В.2.d-2: реестр триггеров «в конце хода» по cardId.
//
// API:
//   registerOnEndOfTurnTrigger(cardId, fn) — fn(state, card) вызывается для
//     каждого живого инстанса с этим id, у которого нет Молчания.
//   runOnEndOfTurnTriggers(state) — проходит детерминированно по всем юнитам
//     ОБЕИХ сторон в порядке: игрок idx=0 (line0 left→right, line1 left→right),
//     потом бот idx=1 (тот же порядок). Для каждого живого юнита проверяет
//     зарегистрированный триггер по cardId.
//
// Молчание блокирует: пропуск, если card.current.silenced или
// card.silenceSources непустой.
//
// Зарегистрировано в onEndOfTurn (deus/index.js) через
// registerOnEndOfTurnExtraHandler — фактическая точка вызова.

import { registerOnEndOfTurnExtraHandler } from '../deus/hooks.js';

const _eotTriggers = new Map();

export function registerOnEndOfTurnTrigger(cardId, fn) {
  if (typeof cardId !== 'string' || typeof fn !== 'function') return;
  _eotTriggers.set(cardId, fn);
}

// Только для тестов: очистить.
export function _resetOnEndOfTurnTriggersForTests() {
  _eotTriggers.clear();
}

// Запустить EOT-триггеры. Зовётся из onEndOfTurn после всех switch'ей.
export function runOnEndOfTurnTriggers(state) {
  if (!state?.players) return;
  if (_eotTriggers.size === 0) return;
  for (let idx = 0; idx < 2; idx++) {
    const p = state.players[idx];
    if (!p) continue;
    // Снимок: line0 left→right, line1 left→right. Триггер может выставить
    // нового юнита (Крыса призывает копию) — копия НЕ должна попасть в
    // текущий проход (её триггер сработает на СЛЕДУЮЩЕМ EOT).
    const snapshot = [];
    for (let line = 0; line < 2; line++) {
      for (let slot = 0; slot < 4; slot++) {
        const u = p.field[line][slot];
        if (u) snapshot.push(u);
      }
    }
    for (const u of snapshot) {
      if (!u.isAlive || !u.isAlive()) continue;
      // Молчание блокирует.
      if (u.current?.silenced) continue;
      if (u.silenceSources && u.silenceSources.size > 0) continue;
      const fn = _eotTriggers.get(u.id);
      if (!fn) continue;
      try {
        fn(state, u);
      } catch (e) {
        console.warn(`[Корпы] EOT-триггер ${u.id} упал:`, e);
      }
    }
  }
}

// Регистрируемся как extra-handler у общего EOT.
registerOnEndOfTurnExtraHandler(runOnEndOfTurnTriggers);
